import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuthStore } from 'stores/authStore';
import ScrollableTabs from '../ScrollableTabs/ScrollableTabs';
import {
  getAvailableContentManagerTabs,
  getContentManagerActiveTab,
  getContentManagerTabLabel,
} from './contentManagerTabs';

const ContentManagerTabBar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const role = useAuthStore((state) => state.role);
  const { t: tPages } = useTranslation('pages');
  const { t: tOwnerPortal } = useTranslation('ownerPortal');
  const availableTabs = getAvailableContentManagerTabs(role);
  const activeTab = getContentManagerActiveTab(location.pathname, availableTabs);

  return (
    <ScrollableTabs
      tabs={availableTabs.map((tab) => ({
        key: tab.key,
        label: getContentManagerTabLabel(tab, tPages, tOwnerPortal),
      }))}
      activeTab={activeTab.key}
      onTabChange={navigate}
      className="mb-4"
    />
  );
};

export default ContentManagerTabBar;
